// extracted by mini-css-extract-plugin
export default {"App":"Support_App__qPyU6","hr":"Support_hr__5vK+i","input":"Support_input__rbLOI","button":"Support_button__nsISr"};